import {lazy, Suspense} from 'react'

import {LazyImportPlayer, Loading} from '@sdox/ui'

import {BlockError} from './BlockError'

import type {XcNwBlock_BlockAutoplayType_Fragment} from '@sdox/api'

const Player = lazy(() => LazyImportPlayer)

export const BlockAutoplayType = (props: XcNwBlock_BlockAutoplayType_Fragment) => {
  const {media} = props

  if (!media) return <BlockError />

  return (
    <Suspense fallback={<Loading className={'aspect-[16/9]'} />}>
      <Player
        autoplay={true}
        loop={true}
        muted={true}
        noControls={true}
        standalone={true}
        url={media.fileUrl}
        thumbnail={media.thumbnailUrl}
        placeholderThumbnail={media.thumbnailUrl380w}
        className={'pullout-rounded-lg no-pullout-rounded-md'}
      />
    </Suspense>
  )
}
